module.exports = __webpack_public_path__ + "static/media/light_resume_button.b17b032f.webp";